<template>
    <div class="content-i">
        <ul class="breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
            </li>
            <li v-for="(info, index) in breadcrumbs" :key="index"
                :class="['breadcrumb-item', { 'active': info.active }]">
                <router-link v-if="info.route !== false" :to="info.route">{{ info.name }}</router-link>
                <span v-else>{{ info.name }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        breadcrumbs: {
            type: Array,
            default: () => []
        }
    }
}
</script>
